var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.41,309.94s-13.85-2-14.56,6.17,9,26.87,23.07,24.23v-4.75s-13.68,2.58-17.36-15c-2-9.72,11-4.5,11-4.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.66,340.34v0c-3.94,3.22-9.24,5.32-16.38,5.32-31,0-27.46-39.67-27.46-39.67h54.93S104.83,329.52,91.66,340.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-150"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "98.32 349.04 49.17 349.04 37.05 344.47 110.45 344.47 98.32 349.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.27,45c124-11,124.24,58.94,180.13,124.13S481.25,263.89,460.18,339,368.11,473.11,280.29,439.73s-138.14-1.33-193.54-31-76-86.91-35.42-154.41S80.32,58.62,233.27,45Z",
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.27,45c124-11,124.24,58.94,180.13,124.13S481.25,263.89,460.18,339,368.11,473.11,280.29,439.73s-138.14-1.33-193.54-31-76-86.91-35.42-154.41S80.32,58.62,233.27,45Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--World--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.8,188.32a64.17,64.17,0,0,1-4.63,7.48,63,63,0,0,1-80.59,18.91q-2.09-1.11-4.05-2.34t-3.79-2.55q-2.22-1.62-4.26-3.4l0,0a2.55,2.55,0,0,1-.24-.23l0,0a63.08,63.08,0,1,1,97.61-17.83Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,129.92c-.67.6-1.77.78-3.51.24-6.25-1.93-9.5,5.09-8.4,5.17s1.86,3.24-.39,4.76-7.49,1-7.15,2.57,2.92,5.47,2.92,5.47,2.3-1.08,3,.27,1.39,5-.3,5.66a2.24,2.24,0,0,0-1.32,2.5l-5.05-.3L285,160l-3.11,2.61-1.66-.88s-1.47-3.81-2.87-1.52l-1.4,2.3-.9,2.06s3.63.81,4.54,2.39l.9,1.58,7.88,2.22L289,173l1.45.77.37,3.94,2.95,1.54,2.94.24,3.59-5a35.9,35.9,0,0,1,1.89,4.34c.36,1.29-.66,4.5-.66,4.5a8.05,8.05,0,0,1-2.56,3c-1.43.74-3.18-1.23-3.05,1.18l.12,2.4-.37,2.67,2.22,1.17,2.09,1.1,1.22,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,168.21l.88.17,4-4.42,3.6-1.46,2.58,1.36c1.07.56,2.14-2.12,2.14-2.12l-.69-.63c-.69-.63.32-4.34.32-4.34a38,38,0,0,0,6,.42c1.59-.19,2.34-.13,3-1.47s.17-1.61.17-1.61a24.07,24.07,0,0,0,1.16-5.21c0-1.73,2.58,1.35,2.58,1.35l1.26-2.39,2.83-2.24,3.68-2.56s5.35-1.54,5.77-.38,2.57,2.1,2.57,2.1l-.92,1.75s-1.18,3.64-2.32,4.41.46,6.34.46,6.34a19.09,19.09,0,0,0-2.78,3.33c-.7,1.34-1.38,1.33-1.38,1.33l-3.49-.48s-4-2.79-5.32-3.49c0,0-2.34,2.51-2.11,4s-.82,1.56-.82,1.56l3.68,3.35.6,2.1,2.2,3-.71,1.35-1.34,2.54.59,2.77,2.39,3.21,1.34,2.92,1.46,4.71.46,2.61,4.3,1.93,1.9-1,3.7-2,1.75,3.48.69,1.75L230.67,199l1.09,2.27.36,2.58-.31,3.44-.63,2.2,2.57,1.35,4.56-.66-.16-3.49a27,27,0,0,1,4.74-2.22c2-.55,1.75-.52,4.14-1.25s1.66-.54,2.81-.93,2.27-.84,2.27-.84l.09-3.63,1.89-6.58,1.17.77c1.16.78,2.9-2,2.9-2l.82-5-2.31-1.21a25.94,25.94,0,0,0-4.16-.49l-3.3-1.74-2.75-4.86a15.9,15.9,0,0,1-2.3-3.25l1.27-2.4,1.56-3,1.63.86,1.5.79,1.59.84,2.6-1.69,1.45-4.06,2-1.78c1.31-1.18,2.21,1,2.21,1l2.14-2.69c2.15-2.68.38-1.44-.72-2.82a2.73,2.73,0,0,0-2.31-1.22l-3.91-4.67-3.07,1.12-.43,1.46c-.44,1.48,0,0-4.51-1.77l-1.49-4.31.89-1,.22-4s-2.6-1.26-4.56-2.32-2.43-3.78-2.43-3.78a9.85,9.85,0,0,1,.89-4.31l-1-2.84-3.69-7.21.63-3.25,2.14-1.35.85-4.32L235.67,111l1.55-2.94,1.1-2.09,1.29-2.44,1-4.95s-.24-.91-.48-1.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.48,206.42a1.38,1.38,0,0,0-.26-.25l0,0L209.3,204l-.44-3.95-1.47-.78s1.79-1.78,1.68-3.19A2.38,2.38,0,0,1,210.2,194l-.48-2.64-.8-.42c-.8-.43-.32-2.64-.32-2.64l-3.42.67-.93,3.6-3.48.89a4.09,4.09,0,0,1-1.67-2.92c.07-1.68.71-1.34.71-1.34H203l2-3.8-.4-1.82-1.45-.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.16,182.77h0c.16.09-.87-4.55-.87-4.55s-1.28-3.39-2.68-4-4.56,1.55-4.56,1.55l-3.53.5-.8,4.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.37,209.79l-.84,2.58q-2-1.22-3.79-2.55l3.95-3.91-.34-4.27s-.72-1.58.67-1.27a3,3,0,0,0,3.18-1.13c.83-.92.72-1.33,2.84-.21s2.26,1.88,2.57,2.73-3.65,6.93-3.65,6.93l1.4.74s-.82,1.9.57,2.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.36,220.33a63.06,63.06,0,0,1-22.15,1.19l.77-2.78s-.73-1.21,2.2-.94,5.16.55,5.16.55l2.33-4.41h4.09l1.34.71,1.15,1.68,2.49,2.4A28.23,28.23,0,0,1,264.36,220.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.32,178.17l2.46-.78,2.15,2.17s4.25.55,2.6,2.4-4.83,1.83-4.83,1.83L263.55,186l-2-2.43-1-1.95.76-1.43Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.86,168.88a5.62,5.62,0,0,0-1.09,2.06l-.15.94-4-2.11,2.17-4.13Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.44,82a6.93,6.93,0,1,1-6.93-6.92A6.92,6.92,0,0,1,399.44,82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.29,191a4.37,4.37,0,1,1-4.37-4.38A4.37,4.37,0,0,1,360.29,191Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.75,52.52a4.38,4.38,0,1,1-4.37-4.37A4.37,4.37,0,0,1,234.75,52.52Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.47,
    cy: 184.55,
    r: 10.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.03,
    cy: 76.7,
    r: 6.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.29,
    cy: 211.9,
    r: 11.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.99,
    cy: 132.27,
    r: 3.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,82.11c.27,2.28.54,4.57.82,6.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.38,60.86,233.43,78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,118.71c-1.85.83-3.7,1.65-5.57,2.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.5,99.44c-11.2,5.79-22.36,11.67-33.79,17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.14,91c-4.19,2-8.35,4.16-12.5,6.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.68,87.39c-1.17.54-2.33,1.09-3.49,1.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.88,170.25q-6.17-.74-12.34-1.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.62,176.92q-27.47-3-54.93-6.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,182.84q-25.33-2.62-50.63-5.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.59,185c-7.39-2.3-15-4-22.2-6.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.39,188.56q-2.52-1.09-5.12-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,134.16l19.37,5.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.08,112.24c10.38,5.78,20.83,11.47,31.53,16.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.58,86.74C123.4,93.9,137.73,102,152.1,110",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.12,82.58c1.22.58,2.43,1.17,3.63,1.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.33,185.47l4.75-1.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,201.52c23.49-5.2,47-10.43,70.61-15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,208.35q13.6-2.91,27.18-5.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.64,385.24H104.36c-9.84,0-39.12-4.15-39.12-4.15H434.76S405.48,385.24,395.64,385.24Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,192.91H392a3.62,3.62,0,0,1,3.62,3.62V370.4a0,0,0,0,1,0,0H104.36a0,0,0,0,1,0,0V196.52A3.62,3.62,0,0,1,108,192.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.76,381.09H65.24a1.15,1.15,0,0,1-.24-2.28l39.36-8.41H395.64L435,378.81A1.15,1.15,0,0,1,434.76,381.09Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.58,
    y: 200.69,
    width: 284.84,
    height: 157.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.29,365.4H243.71a1.45,1.45,0,0,1-1.45-1.45h0a1.45,1.45,0,0,1,1.45-1.46h12.58a1.45,1.45,0,0,1,1.45,1.46h0A1.45,1.45,0,0,1,256.29,365.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.08,196.61a2.08,2.08,0,1,1-2.08-2.07A2.08,2.08,0,0,1,252.08,196.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.84 375.74 88.16 375.74 105.16 371.74 394.84 371.74 411.84 375.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.78,201.87s-65.52,88.81-177,76.74V201.87Z",
    style: {
      fill: "#FFA500",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.82,341s17.31-43.85,108.44-57.7,162.43-50.34,171.92-71.7V355H109.82Z",
    style: {
      fill: "#FFA500",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.82,
    y: 201.87,
    width: 280.35,
    height: 5.44,
    style: {
      fill: "#FFA500",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.82,
    y1: 207.31,
    x2: 390.18,
    y2: 207.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113.67,
    y1: 204.46,
    x2: 121.8,
    y2: 204.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.69,
    y1: 204.46,
    x2: 138.01,
    y2: 204.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.49,
    y1: 204.46,
    x2: 154.62,
    y2: 204.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.15,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.78,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.4,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.03,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.65,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.27,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.9,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.52,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.15,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.77,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.39,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "#FFA500"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367.69,355v-5.65a2.26,2.26,0,0,0-2.26-2.26H354.85v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49A2.23,2.23,0,0,1,333,352.8h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49H315.6v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.22,2.22,0,0,1-2.21-2.22v-3.49H296v3.49a2.22,2.22,0,0,1-2.21,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49H237.1v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.22,2.22,0,0,1-2.21-2.22v-3.49h-6.18v3.49a2.22,2.22,0,0,1-2.21,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49A2.23,2.23,0,0,1,176,352.8h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49H134.57a2.26,2.26,0,0,0-2.26,2.26V355",
    style: {
      fill: "#FFA500",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.69,355v-5.65a2.26,2.26,0,0,0-2.26-2.26H354.85v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49A2.23,2.23,0,0,1,333,352.8h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49H315.6v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.22,2.22,0,0,1-2.21-2.22v-3.49H296v3.49a2.22,2.22,0,0,1-2.21,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49H237.1v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.22,2.22,0,0,1-2.21-2.22v-3.49h-6.18v3.49a2.22,2.22,0,0,1-2.21,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49A2.23,2.23,0,0,1,176,352.8h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49h-6.17v3.49a2.23,2.23,0,0,1-2.22,2.22h-9a2.23,2.23,0,0,1-2.22-2.22v-3.49H134.57a2.26,2.26,0,0,0-2.26,2.26V355",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.15,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.78,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.4,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.03,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.65,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.27,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.9,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.52,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.15,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.77,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.39,
    y: 339.35,
    width: 13.45,
    height: 13.45,
    rx: 2.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,279H178a10.12,10.12,0,0,1-10.12-10.12h0A10.13,10.13,0,0,1,178,258.76H322a10.13,10.13,0,0,1,10.12,10.12h0A10.12,10.12,0,0,1,322,279Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,279H178a10.12,10.12,0,0,1-10.12-10.12h0A10.13,10.13,0,0,1,178,258.76H322a10.13,10.13,0,0,1,10.12,10.12h0A10.12,10.12,0,0,1,322,279Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.33,268.42h0l-.66,6.31h-2.55l-1.32-11.84h1.81l1,9.34h0l.88-9.34h1.8l.91,9.41h0l1-9.41h1.63l-1.32,11.84H182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85,268.42h0l-.66,6.31h-2.55l-1.32-11.84h1.81l1,9.34h0l.88-9.34h1.8l.91,9.41h0l1-9.41h1.63L194,274.73h-2.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.38,268.42h0l-.66,6.31h-2.56l-1.32-11.84h1.82l1,9.34h0l.88-9.34h1.79l.92,9.41h0l1-9.41h1.62l-1.32,11.84H201Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.88,272.94v1.79h-1.79v-1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.24,262.89h2.94c1.86,0,2.78,1,2.78,2.93v6c0,1.89-.92,2.92-2.78,2.92h-2.94Zm1.86,1.69V273h1.05c.59,0,.95-.3.95-1.15v-6.16c0-.85-.36-1.15-.95-1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,265.73c0-1.89,1-3,2.83-3s2.82,1.09,2.82,3v6.16c0,1.9-1,3-2.82,3s-2.83-1.08-2.83-3Zm1.86,6.28c0,.85.37,1.17,1,1.17s1-.32,1-1.17v-6.4c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,271.3h0l1.26-8.41h2.59v11.84h-1.76v-8.49h0l-1.25,8.49h-1.76l-1.35-8.37h0v8.37h-1.62V262.89h2.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,274.73h-1.87l-.32-2.15h-2.29l-.32,2.15h-1.71l1.9-11.84h2.72ZM232.78,271h1.79l-.88-6h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.89,262.89h1.86v11.84h-1.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.8,266.15h0v8.58h-1.67V262.89h2.33L245.3,270h0v-7.09H247v11.84h-1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,266.15h0v8.58h-1.68V262.89h2.34l1.88,7.09h0v-7.09h1.66v11.84h-1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.58,274.73H259.7l-.32-2.15H257.1l-.32,2.15h-1.71L257,262.89h2.73ZM257.33,271h1.8l-.88-6h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.37,271.3h0l1.25-8.41h2.59v11.84h-1.76v-8.49h0l-1.25,8.49h-1.76l-1.35-8.37h0v8.37h-1.62V262.89H265Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.46,267.88H276v1.69h-2.56V273h3.22v1.69H271.6V262.89h5.08v1.69h-3.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.34,262.75c1.81,0,2.74,1.09,2.74,3v.37h-1.76v-.49c0-.84-.34-1.16-.93-1.16s-.93.32-.93,1.16.37,1.51,1.59,2.57c1.55,1.38,2,2.36,2,3.71,0,1.9-.94,3-2.77,3s-2.78-1.08-2.78-3v-.73h1.76V272c0,.85.38,1.15,1,1.15s1-.3,1-1.15-.37-1.51-1.59-2.57c-1.56-1.37-2.05-2.36-2.05-3.71C277.59,263.84,278.53,262.75,280.34,262.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.87,272.94v1.79h-1.79v-1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.45,270.32v1.57c0,1.9-.94,3-2.77,3s-2.78-1.08-2.78-3v-6.16c0-1.89,1-3,2.78-3s2.77,1.09,2.77,3v1.15h-1.76v-1.27c0-.84-.37-1.16-1-1.16s-1,.32-1,1.16V272c0,.85.38,1.15,1,1.15s1-.3,1-1.15v-1.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,265.73c0-1.89,1-3,2.82-3s2.83,1.09,2.83,3v6.16c0,1.9-1,3-2.83,3s-2.82-1.08-2.82-3ZM295.3,272c0,.85.37,1.17,1,1.17s1-.32,1-1.17v-6.4c0-.84-.38-1.16-1-1.16s-1,.32-1,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.22,271.3h0l1.25-8.41h2.59v11.84h-1.76v-8.49h0L305,274.73h-1.75l-1.36-8.37h0v8.37h-1.63V262.89h2.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.1,268.89a3.15,3.15,0,0,0-.48-3.83,3.16,3.16,0,0,0-4.47,4.46A3.22,3.22,0,0,0,321,270a2.59,2.59,0,0,0,.63-.47A2.63,2.63,0,0,0,322.1,268.89Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.29,272.78,323,269.44a4.17,4.17,0,0,0-.62-5.09,4.16,4.16,0,1,0-.8,6.5l3.34,3.34a1,1,0,0,0,1.42,0A1,1,0,0,0,326.29,272.78ZM321,270a3.22,3.22,0,0,1-3.84-.47,3.16,3.16,0,1,1,4.47-4.46,3.15,3.15,0,0,1,.48,3.83,2.63,2.63,0,0,1-.48.63A2.59,2.59,0,0,1,321,270Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.53e067445f241e33339513c1ed467584.svg";
export { ForwardRef as ReactComponent };